import request from '@/utils/request'

// 首页楼层展示内容
export function getStoreyContent(params) {
  return request({
    url: 'api/z/home/getStoreyContent',
    method: 'post',
    params
  })
}

// 获取首页左侧类目&&档口
export function getHomeCategory(data) {
  return request({
    url: 'api/z/home/homeCategory',
    method: 'post',
    data
  })
}

// 获取所有鞋类分类
export function getAllShoesList(params) {
  return request({
    url: '/api/z/productCategory/getAllShoesList',
    method: 'get',
    params
  })
}

// 获取本级类目和本级对应的子集类目
export function getHomeSubCategory(params) {
  return request({
    url: 'api/z/home/homeSubCategory',
    method: 'post',
    params
  })
}

// 档口市(首页档口市场商家列表)
export function getHomeStallList() {
  return request({
    url: '/api/z/home/positionManageByHomeShow',
    method: 'get'
  })
}

// 获取商家品牌列表
export function getBrandList(data) {
  return request({
    url: 'api/z/brand/getBrandList',
    method: 'post',
    data
  })
}

// 获取最顶层广告
export function getAdTop(params) {
  return request({
    url: 'base/top',
    method: 'get',
    params
  })
}

// 获取导航栏菜单
export function getNavigationList(params) {
  return request({
    url: 'navigation/getlist',
    method: 'get',
    params
  })
}

// 热门搜索词汇
export function getHotVocabularyList(data) {
  return request({
    url: 'api/z/home/baseInfo',
    method: 'post',
    data
  })
}

// 获取轮播图
export function getBannerList(params) {
  return request({
    url: '/api/z/ad/getAdList',
    method: 'post',
    params
  })
}

// 获取公告信息
export function getNoticeList(params) {
  return request({
    url: '/api/z/home/getHomeNotice',
    method: 'post',
    params
  })
}

// 获取店铺排行
export function getRankShopList(params) {
  return request({
    url: '/api/z/home/getMchtAmounTrankList',
    method: 'post',
    params
  })
}

// 获取二级栏目自定义区栏目
export function getMarketMenu(params) {
  return request({
    url: '/api/z/custom/column/list',
    method: 'get',
    params
  })
}

//  意见反馈分类
export function getFeedbackClassity(params) {
  return request({
    url: 'feedback/list',
    method: 'get',
    params
  })
}

// 用户意见反馈
export function addFeedback(data) {
  return request({
    url: 'feedback/add',
    method: 'put',
    data
  })
}

// 全站订单滚动
export function getHomeOrder(params) {
  return request({
    url: '/api/z/home/order',
    method: 'get',
    params
  })
}

// 点击广告
export function clickAdvert(params) {
  return request({
    url: '/api/z/ad/addAdShowNum',
    method: 'post',
    params
  })
}

// 获取配置数据
export function configData(params) {
  return request({
    url: '/api/z/sys/dict/list/key',
    method: 'get',
    params
  })
}

// 获取推荐商品店铺数据
export function getRecommendData() {
  return request({
    url: '/api/z/h/home/getHomeRecommendShopAndProduct',
    method: 'get'
  })
}

// 获取新闻资讯栏目列表
export function getNewsList() {
  return request({
    url: '/api/z/article/getNewsList',
    method: 'get'
  })
}

// 获取文章分类根据上级id
export function getNewsListByParentId(params) {
  return request({
    url: '/api/z/article/getListByParentId',
    method: 'get',
    params
  })
}

// 浏览量+1
export function updateProductVideoNum(params) {
  return request({
    url: '/api/z/product/updateProductVideoNum',
    method: 'post',
    params
  })
}

// 友情链接
export function friendshipLinkList(params) {
  return request({
    url: '/api/z/friendShip/list',
    method: 'get',
    params
  })
}

// excel导入批量下单
export function batchFile(params) {
  return request({
    url: '/api/z/home/batchFile',
    method: 'get',
    params
  })
}
